/* assets/charm_bar.js */
(function () {
  // ---------- Global Charms Staging (one singleton for the whole page) ----------
  // Exposed API:
  //  - CIKB.stageBundle({ id, items:[{id,quantity,properties}], display:[{title,img,oos}], meta:{bid,...} })
  //  - CIKB.getStagedLineItems(pop=false) -> flat items[]
  //  - CIKB.peekLineItems() -> flat items[] (non-destructive)
  //  - CIKB.getStagedBundles() -> all bundles[]
  //  - CIKB.removeBundle(id)
  //  - CIKB.restageLineItems(items, meta) -> put items back after a failed add
  // Events:
  //  - document: 'cikb:staged:change'  detail: { staged: bundles[] }

  // One-time style override: keep preorder text red, and DO NOT gray out keys/images for preorder
  // Sold-out keys (continue selling OFF) get grayed out and blocked
  (function injectOnce(){
    if (document.getElementById('cikb-preorder-style')) return;
    const style = document.createElement('style');
    style.id = 'cikb-preorder-style';
    style.textContent = `
      .cikb-key--oos { opacity: 1 !important; text-decoration: none !important; }
      .cikb-key--oos .cikb-key__img { filter: drop-shadow(0 2px 4px rgba(0,0,0,.15)) !important; }
      .cikb-key__preorder, .cikb-staged__note { color:#EA6739 !important; }
      .cikb-key--soldout { opacity: .45 !important; cursor: not-allowed !important; pointer-events: auto !important; }
      .cikb-key--soldout .cikb-key__img { filter: grayscale(.6) opacity(.5) !important; }
      .cikb-key__soldout { font-size:11px; line-height:1.1; font-weight:800; color:#999; }
    `;
    document.head.appendChild(style);
  })();

  window.CIKB = window.CIKB || (() => {
    const staged = [];
    const emit = () => {
      document.dispatchEvent(new CustomEvent('cikb:staged:change', {
        detail: { staged: staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() })) }
      }));
    };

    return {
      stageBundle(bundle) {
        if (!bundle || !Array.isArray(bundle.items) || !bundle.items.length) return;
        staged.push(bundle);
        emit();
      },
      getStagedLineItems(pop = false) {
        const items = staged.flatMap(b => b.items);
        if (pop) { staged.length = 0; emit(); }
        return items;
      },
      peekLineItems() {
        return staged.flatMap(b => b.items);
      },
      getStagedBundles() {
        return staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() }));
      },
      removeBundle(id) {
        const i = staged.findIndex(b => b.id === id);
        if (i > -1) { staged.splice(i, 1); emit(); }
      },
      restageLineItems(items = [], meta = {}) {
        if (!Array.isArray(items) || !items.length) return;
        const id = (meta.id) || (crypto?.randomUUID?.() || String(Date.now()));
        staged.push({ id, items: items.map(x => ({...x})), display: meta.display || [], meta });
        emit();
      }
    };
  })();

  // ---------- Boot across theme lifecycle events ----------
  const START_EVENTS = ["DOMContentLoaded", "shopify:section:load", "shopify:section:select"];
  START_EVENTS.forEach(evt => document.addEventListener(evt, () => boot()));
  if (document.readyState !== "loading") boot();

  function boot() {
    document.querySelectorAll('.cikb[data-bid]').forEach(root => initBlock(root));
  }

  // ---------------- helpers ----------------
  function getPayload(bid) {
    const node = document.getElementById(`cikb-payload-${bid}`);
    if (!node) return {};
    try { return JSON.parse(node.textContent || "{}"); } catch { return {}; }
  }

  const uuid = () =>
    (window.crypto?.randomUUID?.() ||
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random()*16|0, v = c === "x" ? r : (r&0x3|0x8);
        return v.toString(16);
      }));

  const toast = (m) => { try { window?.Shopify?.toast?.show?.(m); } catch {} };

  // Parse a number like "$3", "3", "3.00" out of the price note (used for staged total)
  function parsePricePerCharm(note, fallback = 3) {
    if (typeof note !== "string") return fallback;
    const m = note.replace(',', '.').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    return m ? parseFloat(m[1]) : fallback;
  }

  function moneyFmt(n) {
    try {
      const locale = document.documentElement.lang || "en-US";
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: (window.Shopify?.currency?.active || "USD")
      }).format(n);
    } catch {
      return `$${(+n || 0).toFixed(2)}`;
    }
  }

  // Create a staged area container under the trigger if missing
  function ensureStagedContainer(root, bid) {
    const btn = root.querySelector(`#cikb-open-${bid}`);
    if (!btn) return null;

    let wrap = root.querySelector('.cikb-staged-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cikb-staged-wrap';
      wrap.innerHTML = `
        <style>
          #cikb-${bid} .cikb-staged-wrap{margin:12px 0 6px}
          #cikb-${bid} .cikb-staged__list{display:grid; gap:10px}
          #cikb-${bid} .cikb-staged__item{display:flex; align-items:center; justify-content:space-between; gap:10px; border:1px solid var(--cikb-border, rgba(0,0,0,.08)); border-radius:12px; padding:10px 12px; background:var(--cikb-card,#fff);}
          #cikb-${bid} .cikb-staged__thumbs{display:flex; gap:6px; align-items:center; flex-wrap:wrap}
          #cikb-${bid} .cikb-staged__thumb{width:28px; height:28px; border-radius:6px; border:1px solid rgba(0,0,0,.08); background:#fff; overflow:hidden; display:grid; place-items:center}
          #cikb-${bid} .cikb-staged__thumb img{max-width:100%; max-height:100%; object-fit:contain}
          #cikb-${bid} .cikb-staged__meta{display:flex; flex-direction:column; gap:6px; flex:1; min-width:0}
          #cikb-${bid} .cikb-staged__title{font-weight:800; font-size:13px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis}
          #cikb-${bid} .cikb-staged__price{font-size:13px; opacity:.85}
          #cikb-${bid} .cikb-staged__rm{border:1px solid var(--cikb-border, rgba(0,0,0,.12)); background:#fff; border-radius:999px; padding:6px 10px; cursor:pointer}
          #cikb-${bid} .cikb-staged__note{font-size:12px; font-weight:800;}
        </style>
        <div class="cikb-staged__list" id="cikb-staged-${bid}"></div>
      `;
      btn.insertAdjacentElement('afterend', wrap);
    }
    return wrap.querySelector(`#cikb-staged-${bid}`);
  }

  // Render all staged bundles for THIS block (filtered by meta.bid)
  function renderStagedList(root, bid, DATA) {
    const list = ensureStagedContainer(root, bid);
    if (!list) return;

    const all = window.CIKB.getStagedBundles();
    const stagedForThisBlock = all.filter(b => String(b?.meta?.bid) === String(bid));
    list.innerHTML = '';

    stagedForThisBlock.forEach(bundle => {
      const li = document.createElement('div');
      li.className = 'cikb-staged__item';
      li.dataset.stagedId = bundle.id;

      // thumbs
      const thumbs = document.createElement('div');
      thumbs.className = 'cikb-staged__thumbs';
      (bundle.display || []).forEach(ch => {
        const t = document.createElement('div');
        t.className = 'cikb-staged__thumb';
        if (ch.img) {
          t.innerHTML = `<img src="${ch.img}" alt="${ch.title || ''}">`;
        } else {
          const c = (ch.title || '').slice(0,1).toUpperCase();
          t.textContent = c || '•';
        }
        thumbs.appendChild(t);
      });

      // meta (title + price + optional preorder note BELOW thumbs on its own line)
      const meta = document.createElement('div');
      meta.className = 'cikb-staged__meta';

      const title = document.createElement('div');
      title.className = 'cikb-staged__title';
      const count = (bundle.items || []).length;
      const label = (DATA?.ui?.addLabel || 'ADD TO SET').replace(/ADD TO SET/i, 'Charms');
      title.textContent = `${label} — ${count} charm${count===1?'':'s'}`;

      const price = document.createElement('div');
      price.className = 'cikb-staged__price';
      const per = parsePricePerCharm(DATA?.ui?.priceNote, 3);
      price.textContent = `${moneyFmt(per)} × ${count} = ${moneyFmt(per * count)}`;

      meta.append(title, price);

      const anyOOS = (bundle.display || []).some(d => d && d.oos === true);
      if (anyOOS) {
        const pre = document.createElement('div');
        pre.className = 'cikb-staged__note';
        pre.textContent = DATA?.ui?.oosPreorderNote || " ";
        meta.appendChild(pre); // <<— new line under charms images (meta is under thumbs)
      }

      // remove
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cikb-staged__rm';
      rm.textContent = 'Delete';
      rm.addEventListener('click', () => {
        window.CIKB.removeBundle(bundle.id);
      });

      li.append(thumbs, meta, rm);
      list.appendChild(li);
    });

    // Update trigger label when at least one staged
    const openBtn = root.querySelector(`#cikb-open-${bid}`);
    if (openBtn) {
      if (stagedForThisBlock.length > 0) {
        openBtn.textContent = DATA?.ui?.btnHasStaged || 'ADD ANOTHER SET OF CHARMS';
      } else {
        openBtn.textContent = DATA?.ui?.btnDefault || (DATA?.ui?.heading || 'ADD CHARM PERSONALIZATION');
      }
    }
  }

  // ---------------- per-block init ----------------
  async function initBlock(root) {
    if (root.__cikbMounted) return;
    const bid = root.dataset.bid;
    if (!bid) return;
    root.__cikbMounted = true;

    const DATA = getPayload(bid);
    const pricePerCharm = parsePricePerCharm(DATA?.ui?.priceNote, 3);

    // elements
    const $ = id => document.getElementById(id);
    const el = {
      open:   $(`cikb-open-${bid}`),
      modal:  $(`cikb-modal-${bid}`),
      strap:  $(`cikb-strap-${bid}`),
      count:  $(`cikb-count-${bid}`),
      clear:  $(`cikb-clear-${bid}`),
      colors: $(`cikb-colors-${bid}`),
      keygrid:$(`cikb-keygrid-${bid}`),
      add:    $(`cikb-add-${bid}`),
    };
    if (!el.open || !el.modal) return;

    // ensure closed initially
    try { el.modal.removeAttribute("open"); } catch {}

    // push style variables from payload so theme colors “stick”
    applyStyleVars(el.modal, DATA?.styles || {});

    // per-block state
    const S = { strap: [], currentColorIndex: 0 };
    const setCount = () => { if (el.count) el.count.textContent = String(S.strap.length); updateCTA(); };

    // listen for global staged changes to keep this block’s list in sync
    const onStageChange = () => renderStagedList(root, bid, DATA);
    document.addEventListener('cikb:staged:change', onStageChange);

    // ---------- open/close ----------
    function openModal() {
      try {
        if (typeof el.modal.showModal === "function" && !el.modal.open) {
          el.modal.showModal();
        } else {
          el.modal.setAttribute("open","open");
        }
      } catch {
        el.modal.setAttribute("open","open");
      }
      el.modal.style.display = "grid";
      el.modal.style.position = "fixed";
      el.modal.style.zIndex = "9999";
      document.documentElement.style.overflow="hidden";
      document.body.style.overflow="hidden";
    }
    function closeModal() {
      try { if (el.modal.open) el.modal.close(); } catch {}
      el.modal.removeAttribute("open");
      el.modal.style.display = "";
      el.modal.style.position = "";
      el.modal.style.zIndex = "";
      document.documentElement.style.overflow="";
      document.body.style.overflow="";
    }

    // ---------- style vars ----------
    function applyStyleVars(scope, vars){
      if (!scope) return;
      const map = {
        surface:"--cikb-surface",
        card:"--cikb-card",
        border:"--cikb-border",
        strapBg:"--cikb-strap-bg",
        strapBorder:"--cikb-strap-border",
        chipBg:"--cikb-chip-bg",
        chipText:"--cikb-chip-text",
        heading:"--cikb-heading",
        body:"--cikb-body",
        keyBg:"--cikb-key-bg",
        keyBorder:"--cikb-key-border",
        keyLetter:"--cikb-key-letter",
        ctaBg:"--cikb-cta-bg",
        ctaText:"--cikb-cta-text",
        preview:"--cikb-preview"
      };
      Object.keys(map).forEach(k=>{
        if (vars[k]) scope.style.setProperty(map[k], vars[k]);
      });
    }

    // ---------- preview swatches (strap color) ----------
    function bindPreviewSwatches() {
      const row = el.modal.querySelector('.cikb-preview-swatches');
      if (!row) return;
      const nodes = Array.from(row.querySelectorAll('.sw'));
      const setActive = (idx) => nodes.forEach((n,i)=>n.classList.toggle('is-active', i===idx));
      nodes.forEach((n,i)=>{
        n.addEventListener('click', ()=>{
          const hex = getComputedStyle(n).getPropertyValue('--sw').trim();
          el.modal.style.setProperty('--cikb-preview', hex || DATA?.styles?.preview || '#47B276');
          setActive(i);
        });
      });
      if (nodes.length) {
        const hex = getComputedStyle(nodes[0]).getPropertyValue('--sw').trim();
        el.modal.style.setProperty('--cikb-preview', hex || DATA?.styles?.preview || '#47B276');
        setActive(0);
      } else if (DATA?.styles?.preview) {
        el.modal.style.setProperty('--cikb-preview', DATA.styles.preview);
      }
    }

    // ---------- color pills ----------
    function bindColorPills(){
      if (!el.colors) return;
      const pills = Array.from(el.colors.querySelectorAll(".cikb-color"));
      const activate = (idx) => pills.forEach((b,i)=>b.classList.toggle('is-active', i===idx));
      pills.forEach((btn, idx)=>{
        btn.addEventListener("click", ()=>{
          S.currentColorIndex = idx;
          activate(idx);
          renderKeys();
        });
      });
      activate(0);
    }

    // ---------- render strap ----------
    function renderStrap(){
      if (!el.strap) return;
      el.strap.innerHTML = "";
      S.strap.forEach((it, i) => {
        const wrap = document.createElement("div");
        wrap.className = "cikb-strap__charm";

        const img = document.createElement("img");
        img.className = "cikb-strap__img";
        img.alt = it.title || "";
        img.src = it.img || "";

        const rm  = document.createElement("button");
        rm.type = "button";
        rm.className = "cikb-strap__rm";
        rm.textContent = "×";
        rm.addEventListener("click", (ev)=>{ ev.preventDefault(); ev.stopPropagation(); S.strap.splice(i,1); renderStrap(); setCount(); });

        wrap.append(img, rm);
        el.strap.appendChild(wrap);
      });
    }

    // ---------- render keyboard ----------
    function renderKeys(){
      if (!el.keygrid) return;
      el.keygrid.innerHTML = "";

      const color = DATA.charms?.[S.currentColorIndex];
      if (!color) return;

      color.variants.forEach(v=>{
        const b = document.createElement("button");
        b.type = "button";
        b.className="cikb-key";

        // Sold out = variant unavailable (continue selling OFF + no stock) → block completely
        const isSoldOut = !v.available;
        // Preorder = variant available but inventory depleted (continue selling ON) → allow
        const isPreorder = v.available && (typeof v.qty === "number" && v.qty <= 0);

        if (isSoldOut) { b.classList.add("cikb-key--soldout"); }
        else if (isPreorder) { b.classList.add("cikb-key--oos"); }

        const box = document.createElement("div");
        box.className = "cikb-key__box";

        if (v.image) {
          const im = document.createElement("img");
          im.className = "cikb-key__img";
          im.alt = v.title || "";
          im.src = v.image;
          box.appendChild(im);
        } else {
          const tile = document.createElement("span");
          tile.className = "cikb-key__tile";
          tile.textContent = (v.title || "").slice(0,1).toUpperCase();
          box.appendChild(tile);
        }

        const cap = document.createElement("span");
        cap.className = "cikb-key__label";
        cap.textContent = v.title || "Variant";

        b.append(box, cap);

        // Sold out note (gray, blocked)
        if (isSoldOut) {
          const note = document.createElement("span");
          note.className = "cikb-key__soldout";
          note.textContent = "Out of stock";
          b.appendChild(note);
        }
        // Preorder note BELOW the image and label (red)
        else if (isPreorder) {
          const note = document.createElement("span");
          note.className = "cikb-key__preorder";
          note.textContent = DATA?.ui?.oosPreorderNote || " ";
          b.appendChild(note);
        }

        b.addEventListener("click", ()=>{
          // Block sold-out charms (continue selling OFF)
          if (isSoldOut) { return; }
          if (S.strap.length >= (DATA.maxChars||12)) { toast(DATA?.ui?.maxMsg || "Max charms reached"); return; }
          // Allow clicking when preorder (continue selling ON)
          S.strap.push({ variantId: v.id, title: v.title, img: v.image || "", oos: isPreorder });
          renderStrap(); setCount();
          ensureStrapEdgeScroll();
        });

        el.keygrid.appendChild(b);
      });
    }

    // Keep strap scrolled to the end as people add charms
    function ensureStrapEdgeScroll(){
      const bar = el.strap?.closest('.cikb-strap')?.querySelector('.cikb-strap__bar');
      if (!bar) return;
      requestAnimationFrame(()=>{ bar.scrollLeft = bar.scrollWidth; });
    }

    // ---------- CTA live price ----------
    function updateCTA(){
      if (!el.add) return;
      const count = S.strap.length;
      const total = count * pricePerCharm;
      let sub = el.add.querySelector(".cikb-cta__sub");
      if (!sub) {
        sub = document.createElement("span");
        sub.className = "cikb-cta__sub";
        el.add.appendChild(sub);
      }
      if (count > 0){
        sub.textContent = `${count} × ${moneyFmt(pricePerCharm)} = ${moneyFmt(total)}`;
      } else {
        sub.textContent = DATA?.ui?.ctaSub || "";
      }
    }

    // ---------- events ----------
    el.open.addEventListener("click", (e)=>{ e.preventDefault(); openModal(); });
    el.modal.querySelectorAll("[data-close]").forEach(b => b.addEventListener("click", closeModal));
    el.modal.addEventListener("cancel", (e)=>{ e.preventDefault(); closeModal(); });
    el.modal.addEventListener("click", (e)=>{ if (e.target === e.currentTarget) closeModal(); });

    el.clear?.addEventListener("click", ()=>{
      S.strap = []; renderStrap(); setCount();
      const bar = el.strap?.closest('.cikb-strap')?.querySelector('.cikb-strap__bar');
      if (bar) bar.scrollLeft = 0;
    });

    // ---------- Stage or Add-to-cart ----------
    el.add?.addEventListener("click", async ()=>{
      if (!S.strap.length) { alert(DATA?.ui?.pickOneMsg || "Pick at least one charm"); return; }

      // Notify debugging hooks if any
      try {
        const stagedDetail = { bid, strap: [...S.strap] };
        window.dispatchEvent(new CustomEvent("cikb:saved", { detail: stagedDetail }));
        document.dispatchEvent(new CustomEvent("cikb:saved", { detail: stagedDetail }));
      } catch {}

      const preorderNote = DATA?.ui?.oosPreorderNote || " ";

      if (DATA.stageOnly === true) {
        // Build a UNIVERSAL bundle that Buy Buttons can later add with /cart/add.js
        const bundleId    = uuid();
        const bundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";

        const items = S.strap.map((ch, idx) => ({
          id: String(ch.variantId),
          quantity: 1,
          properties: {
            _bundleId: bundleId,
            _bundleParentVariantId: DATA.parentVariantGid || "",
            _bundleTitle: bundleTitle,
            // Optional child attributes used by cart transform
            _Letter: (ch.title || "").trim(),
            _OrderIndex: String(idx),
            _IsPreorder: ch.oos ? "1" : "0",
            _PreorderNote: ch.oos ? preorderNote : ""
          }
        }));

        // Separate light display data (for thumbnails/labels in the staged UI)
        const display = S.strap.map(ch => ({ title: ch.title, img: ch.img || "", oos: !!ch.oos }));

        // Save into the global stage with a back-reference to this block
        window.CIKB.stageBundle({
          id: bundleId,
          items,
          display,
          meta: {
            bid,
            count: items.length,
            pricePerCharm,
            bundleTitle
          }
        });

        toast(DATA?.ui?.toastAdded || "Saved!");
        closeModal();

        // Reset working strap for next bundle
        S.strap = [];
        renderStrap(); setCount();
        return; // do NOT add to cart now
      }

      // Otherwise: add directly to cart now
      const directBundleId    = uuid();
      const directBundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";
      try {
        for (const [idx, ch] of S.strap.entries()){
          const f = new FormData();
          f.append("id", String(ch.variantId));
          f.append("quantity", "1");
          f.append("properties[_bundleId]", directBundleId);
          f.append("properties[_bundleParentVariantId]", DATA.parentVariantGid || "");
          f.append("properties[_bundleTitle]", directBundleTitle);

          // Optional child attributes
          f.append("properties[_Letter]", (ch.title || "").trim());
          f.append("properties[_OrderIndex]", String(idx));
          if (ch.oos) {
            f.append("properties[_IsPreorder]", "1");
            f.append("properties[_PreorderNote]", preorderNote);
          }

          const res = await fetch("/cart/add.js", { method:"POST", headers:{ "Accept":"application/json" }, body: f });
          if (!res.ok) throw new Error(await res.text());
        }
        toast(DATA?.ui?.toastAdded || "Bundle added!");
        closeModal();
        if (DATA.goToCart) document.dispatchEvent(new CustomEvent('cart:refresh')); location.href = '/cart';;
        S.strap = [];
        renderStrap(); setCount();
      } catch (e){
        console.error("[cikb] add bundle failed:", e);
        alert(DATA?.ui?.toastError || "Add to cart failed. See console for details.");
      }
    });

    // ---------- boot ----------
    bindPreviewSwatches();
    bindColorPills();
    renderKeys();
    renderStrap();
    setCount();

    // First render (pull whatever is already staged for this block)
    renderStagedList(root, bid, DATA);

    // Optional: allow external open via event
    window.addEventListener('cikb:open', (ev) => {
      const targetBid = ev?.detail?.bid;
      if (String(targetBid) === String(bid)) openModal();
    });

    // expose for debugging
    window.__cikb = window.__cikb || {};
    window.__cikb[bid] = {
      open: openModal,
      close: closeModal,
      state: S,
      els: el,
      data: DATA
    };
  }
})();
